import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import { useFormContext } from "react-hook-form";
import type { AuthProvider } from "@/app/oauth/types";
import { RequestParametersInput } from "./request-parameters-input";

export const AuthorizeRequestFields = () => {
  const form = useFormContext<AuthProvider>();

  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="oauth2.authorize_request.params"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <RequestParametersInput
                form={form}
                name={field.name}
                onChange={field.onChange}
                value={field.value || {}}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
